import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useLocalizedStrings } from '../../localization/LocalizedStringsProvider';
import { fillHeight } from '../../theme';

// Placeholder. The nav item exists so the section's shape is settled before the feature is built; it will
// share the brand-wide tag list with Ad Banner.
const CrossSell = () => {
    const strings = useLocalizedStrings();

    return (
        <Box sx={{ ...fillHeight, overflow: 'auto', p: 2 }}>
            <Stack spacing={2}>
                <Typography variant="h6">{strings.crossSell}</Typography>
                <Typography variant="body2" color="text.secondary">{strings.crossSellComingSoon}</Typography>
            </Stack>
        </Box>
    );
};

export default CrossSell;
